import ProjectCore, { IProject } from "./ProjectCore";

export interface IProjectLiabilityTemporary extends IProject {}

export default class ProjectLiabilityTemporary extends ProjectCore {
  constructor(dto: IProjectLiabilityTemporary) {
    super(dto);
  }
}
